import * as d3 from 'd3';
import { DataElement } from './types';

export const OPACITY_DELTA = 0.025;
export const MAX_CHART_RENDER_TIME = 1000;
export const tooltipDiv = makeTooltipDiv();
export const ChartWidth = 685;
export const ChartHeight = 576;
export const ChartMargin = {
    left: 54,
    bottom: 32
};

export const ScaleX = d3.scaleLinear()
    .domain([1970, 2025])
    .range([0, ChartWidth]);

export const AxisX = d3.axisBottom(ScaleX)
    .ticks(16)
    .tickFormat(d3.format('d'))
    .tickSizeOuter(0);

export function initializeSvg(svgId: string, opts?: any) {
    if (!opts) opts = {};

    const svg = document.getElementById(svgId) as HTMLElement;
    svg.setAttribute('width', opts.ChartWidth ? opts.ChartWidth.toString() : ChartWidth.toString());
    svg.setAttribute('height', opts.ChartHeight ? opts.ChartHeight.toString() : ChartHeight.toString());
}

export function formatNumberWithCommas(num: number) {
    const w = num.toString();

    let result = "";
    for(let i = w.length - 1; i >= 0; i--) {
        if ((i - (w.length - 1)) % 3 === 0 && (i - (w.length - 1)) !== 0) {
            result = "," + result;
        }
        result = w.charAt(i) + result;
    }

    return result;
}

export function makeTooltipDiv() {
    const tooltipDiv = d3.select("body")
        .append("div")
        .attr("class", "tooltip")
        .style("opacity", 0);

    return tooltipDiv;
}

export function showTooltip(tooltipDiv: d3.Selection<HTMLDivElement, unknown, HTMLElement, any>, datum: DataElement) {
    tooltipDiv.transition().duration(200).style("opacity", 0.85);
    tooltipDiv.style("left", (d3.event.pageX + 4) + 'px');
    tooltipDiv.style("top", (d3.event.pageY - 48) + 'px');
    tooltipDiv.html(`
        <div>
            <h6>${datum.CPU}</h6>
            <strong>${datum.YEAR}</strong>
        </div>
        <div class="tooltip-subtitle">
            ${datum.MIPS} MIPS, ${datum.TDP} Watt TDP
        </div>
        <div class="tooltip-subtitle">
            <strong>${(parseFloat(datum.TDP || '0') / parseFloat(datum.MIPS)).toFixed(5)} Watt/MIPS</strong>
        </div>
    `);
}

export function hideTooltip(tooltipDiv: d3.Selection<HTMLDivElement, unknown, HTMLElement, any>) {
    tooltipDiv.transition().duration(500).style("opacity", 0);
}

export function addLabelForAxisX(label: string, svgId: string) {
    d3.select(`svg[id=${svgId}]`)
        .append('text')
        .attr('transform', `translate(${ChartWidth / 2}, ${ChartHeight})`)
        .text(label);
}

export function addLabelForAxisY(label: string, svgId: string) {
    d3.select(`svg[id=${svgId}]`)
        .append('text')
        .attr('transform', `translate(${ChartMargin.left / 2}, ${ChartMargin.bottom - 12})`)
        .text(label);
}